import { Injectable } from '@angular/core';
import { SettingsService } from '../settings.service';
import { Response } from '@angular/http';
import { HttpResponse, HttpClient } from '@angular/common/http';
import { CriterioAvaliacao } from '../comum/modelos/criterio-avaliacao';
import { CriterioAvaliacaoRotinaCliente } from '../comum/modelos/criterio-avaliacao-rotina-cliente';
import { CriticidadeRotina } from '../comum/modelos/criticidade-rotina';
import { ListaProcessoSetor } from '../comum/modelos/lista-processo-setor';
import { ProcessoCliente } from '../comum/modelos/processo-cliente';
import { ProcessoSetor } from '../comum/modelos/processo-setor';
import { Rotina } from '../comum/modelos/rotina';
import { RotinaCliente } from '../comum/modelos/rotina-cliente';
import { RotinaProcesso } from '../comum/modelos/rotina-processo';
import { Observable } from 'rxjs/Observable';
import { ReincidenciaRotina } from '../comum/modelos/reincidencia-rotina';
import { CriterioReincidenciaRotina } from '../comum/modelos/criterio-reincidencia-rotina';
import { FiltroReincidencia } from '../comum/modelos/filtro-reincidencia';
import { Reincidencia } from '../comum/modelos/reincidencia';

@Injectable()
export class RotinaService {

  private _host: string;

  constructor(
    private _settingsService: SettingsService,
    private _http: HttpClient) {
    this._host = this._settingsService.obterHostBase() + '/rotinas/';
  }

  removerRotinaHttp(idSetor: number, callback: (responseJson: any) => void): void {
    const self = this;
  }

  cadastrarRotinaHttp(rotina: Rotina): Observable<HttpResponse<Rotina>> {
    return this._http
      .post(this._host, rotina, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  obterRotinaPorIdHttp(id: number): Observable<Rotina> {
    return this._http.get(this._host + id)
      .catch(this.handleError);
  }

  obterRotinaClientePorIdHttp(id: number): Observable<RotinaCliente> {
    return this._http.get(this._host + 'rotina-cliente/' + id)
      .catch(this.handleError);
  }

  obterListaProcessoSetorHttp(id: number): Observable<ListaProcessoSetor[]> {
    return this._http.get(this._host + 'processo-setor/' + id)
      .catch(this.handleError);
  }

  atualizarRotinaClienteHttp(rotinaCliente: RotinaCliente): Observable<HttpResponse<RotinaCliente>> {
    return this._http
      .put(this._host + 'rotina-cliente/', rotinaCliente, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  atualizarRotinaHttp(rotina: Rotina): Observable<HttpResponse<Rotina>> {
    return this._http
      .put(this._host, rotina, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  cadastrarRotinaClienteHttp(rotinaCliente: RotinaCliente): Observable<HttpResponse<RotinaCliente>> {
    return this._http
      .post(this._host + 'rotina-cliente/', rotinaCliente, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerRotinaClienteHttp(idRotinaCliente: number): Observable<HttpResponse<RotinaCliente>> {
    return this._http.delete(this._host + 'rotina-cliente/' + idRotinaCliente, {
      observe: 'response'
    })
      .catch(this.handleError);
  }

  obterRotinasClienteHttp(id: number): Observable<RotinaCliente[]> {
    return this._http.get(this._host + 'cliente/' + id)
      .catch(this.handleError);
  }

  obterRotinasHttp(): Observable<Rotina[]> {
    return this._http.get(this._host)
      .catch(this.handleError);
  }

  cadastrarRotinasClienteHttp(rotinasCliente: RotinaCliente[]): Observable<HttpResponse<RotinaCliente[]>> {
    return this._http
      .post(this._host + 'rotina-cliente/lista', rotinasCliente, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerRotinasClienteHttp(rotinasCliente: RotinaCliente[]): Observable<HttpResponse<RotinaCliente[]>> {
    return this._http
      .patch(this._host + 'rotina-cliente/', rotinasCliente, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  obterRotinasClienteFromProcessosHttp(processos: ProcessoCliente[]): Observable<RotinaCliente[]> {
    let ids: string;

    for (let i = 0, len = processos.length; i < len; i++) {
      if (i === 0) {
        ids = '?id=' + processos[i].idProcessoCliente;
      } else {
        ids = ids + '&id=' + processos[i].idProcessoCliente;
      }
    }

    return this._http.get(this._host + 'cliente/processo/' + ids)
      .catch(this.handleError);
  }

  obterCriticidadesRotinaHttp(): Observable<CriticidadeRotina[]> {
    return this._http.get(this._host + 'criticidade-rotina')
      .catch(this.handleError);
  }

  obterCriteriosAvaliacaoHttp(): Observable<CriterioAvaliacao[]> {
    return this._http.get(this._host + 'criterio-avaliacao')
      .catch(this.handleError);
  }

  obterRotinasProcessosHttp(processos: ProcessoSetor[]): Observable<RotinaProcesso[]> {
    const params = new URLSearchParams();
    let ids: string;

    for (let i = 0, len = processos.length; i < len; i++) {
      if (i === 0) {
        ids = '?id=' + processos[i].idProcessoSetor;
      } else {
        ids = ids + '&id=' + processos[i].idProcessoSetor;
      }
    }

    return this._http.get(this._host + 'processo/' + ids)
      .catch(this.handleError);
  }

  obterRotinasProcessosFromProcessosClienteHttp(processos: ProcessoCliente[]): Observable<RotinaProcesso[]> {
    const params = new URLSearchParams();
    let ids: string;

    for (let i = 0, len = processos.length; i < len; i++) {
      if (i === 0) {
        ids = '?id=' + processos[i].idProcessoCliente;
      } else {
        ids = ids + '&id=' + processos[i].idProcessoCliente;
      }
    }

    return this._http.get(this._host + 'processo-cliente/' + ids)
      .catch(this.handleError);
  }

  obterRotinasClienteFromProcessosSetorHttp(processos: ProcessoSetor[]): Observable<RotinaCliente[]> {
    let ids: string;

    for (let i = 0, len = processos.length; i < len; i++) {
      if (i === 0) {
        ids = '?id=' + processos[i].idProcessoSetor;
      } else {
        ids = ids + '&id=' + processos[i].idProcessoSetor;
      }
    }

    return this._http.get(this._host + 'rotina-cliente-from-processo-setor/' + ids)
      .catch(this.handleError);
  }

  obterRotinasProcessoHttp(idProcessoSetor: number): Observable<RotinaProcesso[]> {
    return this._http.get(this._host + 'processo/' + idProcessoSetor)
      .catch(this.handleError);
  }

  obterRotinaProcessoHttp(idRotinaProcesso: number): Observable<RotinaProcesso> {
    return this._http.get(this._host + 'rotina-processo/' + idRotinaProcesso)
      .catch(this.handleError);
  }


  cadastrarRotinasProcessoHttp(rotinasProcesso: RotinaProcesso[]): Observable<HttpResponse<RotinaProcesso[]>> {
    return this._http
      .post(this._host + 'processo/', rotinasProcesso, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerRotinasProcessoHttp(rotinasProcesso: RotinaProcesso[]): Observable<HttpResponse<RotinaProcesso[]>> {
    return this._http
      .patch(this._host + 'processo/', rotinasProcesso, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  obterRotinasClienteObrigacaoFotoHttp(id: number): Observable<RotinaCliente[]> {
    return this._http.get(this._host + 'rotina-cliente/foto/' + id)
      .catch(this.handleError);
  }

  obterCriterioAvaliacaoRotinaClienteObrigacaoFotoHttp(id: number): Observable<CriterioAvaliacaoRotinaCliente[]> {
    return this._http.get(this._host + 'rotina-cliente/criterio-avaliacao/foto/' + id)
      .catch(this.handleError);
  }

  obterCriteriosAvaliacaoRotinaClienteHttp(id: number): Observable<CriterioAvaliacaoRotinaCliente[]> {
    return this._http.get(this._host + 'rotina-cliente/criterio-avaliacao/' + id)
      .catch(this.handleError);
  }

  obterCriterioAvaliacaoRotinaClienteHttp(id: number): Observable<CriterioAvaliacaoRotinaCliente> {
    return this._http.get(this._host + 'rotina-cliente/criterio-avaliacao-rotina-cliente/' + id)
      .catch(this.handleError);
  }

  obterRotinasProcessosFromRotinasClienteHttp(rotinas: number[]): Observable<RotinaProcesso[]> {
    let ids: string;

    for (let i = 0, len = rotinas.length; i < len; i++) {
      if (i === 0) {
        ids = '?id=' + rotinas[i];
      } else {
        ids = ids + '&id=' + rotinas[i];
      }
    }

    return this._http.get(this._host + 'rotina-processo-from-rotina-cliente/' + ids)
      .catch(this.handleError);
  }

  obterReincidenciaRotinaHttp(idRotinaCliente: number): Observable<ReincidenciaRotina> {
    return this._http.get(this._host + 'reincidencia-rotina/' + idRotinaCliente)
      .catch(this.handleError);
  }


  cadastrarReincidenciaRotinaHttp(reincidencia: ReincidenciaRotina): Observable<HttpResponse<ReincidenciaRotina>> {
    return this._http
      .post(this._host + 'reincidencia-rotina/', reincidencia, {
        observe: 'response'
      })
      .catch(this.handleError);
  }


  atualizarReincidenciaRotinaHttp(reincidencia: ReincidenciaRotina): Observable<HttpResponse<ReincidenciaRotina>> {
    return this._http
      .put(this._host + 'reincidencia-rotina/', reincidencia, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  apagarReincidenciaRotinaHttp(idReincidenciaRotina: number): Observable<HttpResponse<ReincidenciaRotina>> {
    return this._http.delete(this._host + 'reincidencia-rotina/' + idReincidenciaRotina)
      .catch(this.handleError);
  }

  cadastrarCriteriosReincidenciaRotinaHttp(criterios: CriterioReincidenciaRotina[]):
    Observable<HttpResponse<CriterioReincidenciaRotina[]>> {
    return this._http
      .post(this._host + 'criterio-reincidencia-rotina/', criterios, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  atualizarCriterioReincidenciaRotinaHttp(criterio: CriterioReincidenciaRotina): Observable<HttpResponse<CriterioReincidenciaRotina>> {
    return this._http
      .put(this._host + 'criterio-reincidencia-rotina/', criterio, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerCriteriosReincidenciaRotinaHttp(criterios: CriterioReincidenciaRotina[]):
    Observable<HttpResponse<CriterioReincidenciaRotina[]>> {
    return this._http
      .patch(this._host + 'criterio-reincidencia-rotina/', criterios, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  obterReincidenciasHttp(filtroReincidencia: FiltroReincidencia): Observable<HttpResponse<Reincidencia[]>> {
    return this._http.post(this._host + 'listar-reincidencias/search/', filtroReincidencia, {
      observe: 'response'
    }).catch(this.handleError);
  }

  private handleError(error: Response) {

    console.error(error);

    return Observable.throw(error.json().error || 'Server error');

  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/rotina/rotina.service.ts